export enum VariantStatus {
  SoldOut = 'SoldOut',
  PreOrder = 'PreOrder',
  Available = 'Available',
  NoVariant = 'NoVariant',
}
